<template>
    <section>
        <form @submit="login" v-bind:class="{error: error}" id="login" class="form-login" method="post" action="/auth/login/">
            <div class="form-wrapper">
                <div class="form-group mb-4">
                    <svg viewBox="0 0 512 512"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"/></svg>
                    <input v-bind:class="{error: error}" v-model="email" type="email" placeholder="Email" class="form-control icon" required />
                </div>
                <div class="form-group mb-4">
                    <svg viewBox="0 0 512 512"><path d="M376 186h-20v-40c0-55-45-100-100-100S156 91 156 146v40h-20c-22.002 0-40 17.998-40 40v200c0 22.002 17.998 40 40 40h240c22.002 0 40-17.998 40-40V226c0-22.002-17.998-40-40-40zM256 368c-22.002 0-40-17.998-40-40s17.998-40 40-40 40 17.998 40 40-17.998 40-40 40zm62.002-182H193.998v-40c0-34.004 28.003-62.002 62.002-62.002 34.004 0 62.002 27.998 62.002 62.002v40z"/></svg>
                    <input v-bind:class="{error: error}" v-model="password" type="password" placeholder="Password" class="form-control icon" required />
                </div>
                <div class="d-flex align-items-center mb-4">
                    <div class="accept-mark d-flex">
                        <input class="checkbox-mark" id="cbx-accept" type="checkbox" required />
                        <label class="cbx" for="cbx-accept"></label>
                    </div>
                    <label class="accept-mark-label ml-2 mb-0 c-pointer" for="cbx-accept"><small class="d-flex align-items-center">I approve<router-link :to="{name: 'terms-and-conditions'}" class="ml-1">Terms & Conditions</router-link></small></label>
                </div>
                <p class="text-center mt-3" v-if="error"><i>Wrong email or password.</i></p>
                <div class="d-flex flex-column align-items-center text-center mb-4 login-links">
                    <router-link class="mb-1" :to="{name: 'reset-password'}">
                        <small>Forgot your password?</small>
                    </router-link>
                    <router-link :to="{name: 'register'}">
                        <small>Apply for account</small>
                    </router-link>
                </div>
                <button type="submit" class="btn btn-lg btn-primary center" v-bind:class="{load: loading}">
                    Login
                    <div class="loading"></div>
                </button>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    name: 'AuthLogin',
    metaInfo: {
        title: 'Login'
    },
    data () {
        return {
            email: null,
            password: null,
            error: false,
            loading: false
        }
    },
    methods:{
        login: function (e) {
            e.preventDefault();
            this.loading = true;
            this.error = false;
            this.$store.dispatch('login', {
                email: this.email,
                password: this.password,
            }).then(() => {
                this.loading = false,
                this.$router.push('/')
            }).catch(error => {
                this.loading = false,
                this.error = true
            });
        }
    }
}
</script>